import React from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import RegisterCom from '../../components/RegisterComponents';

const Register = () => {

    return (
        <div>
            <Header/>
                <RegisterCom/>
        </div>
        
    );
};

export default Register;